/**
 * preferences — thin storage-adapter seam for key/value string preferences.
 *
 * Currently wraps localStorage directly. When migrating to Capacitor, swap
 * the implementation here to use `@capacitor/preferences` (Preferences.get /
 * Preferences.set). Components and hooks read/write through this module only
 * — never window.localStorage directly.
 *
 * Capacitor swap point: replace get/set bodies with:
 *   import { Preferences } from '@capacitor/preferences';
 *   export async function getPreference(key: string): Promise<string | null> {
 *     const { value } = await Preferences.get({ key });
 *     return value;
 *   }
 *   export async function setPreference(key: string, value: string): Promise<void> {
 *     await Preferences.set({ key, value });
 *   }
 *   export async function removePreference(key: string): Promise<void> {
 *     await Preferences.remove({ key });
 *   }
 */

export function getPreference(key: string): string | null {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(key);
}

export function setPreference(key: string, value: string): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(key, value);
}

export function removePreference(key: string): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(key);
}
